module.exports = __webpack_public_path__ + "img/art-composer-shipping.20a6f4ab.png";